/* ============================================================
   VAPORSEGURO — Limpiador a vapor portátil (slug 'vaporseguro').

   Producto Shopify "A604 Limpiador a Vapor Portátil" (8641756790945).
   Cada bundle (1/2/3 unidades) es UNA variante per-unit con el MISMO SKU
   A604 (el que Dropi ya tiene mapeado), y la landing manda quantity = N:
     1 Unidad   -> $149.900 x 1 = $149.900
     2 Unidades -> $114.950 x 2 = $229.900
     3 Unidades ->  $99.900 x 3 = $299.700
   Así el total cuadra con lo que muestra la landing Y el pedido lleva las
   unidades reales para que Dropi despache la cantidad correcta.
   Requiere quantityControlsHidden:true en Releasit (global) para que el
   cliente no pueda cambiar la cantidad y desarmar el precio.
   Ver memory/project_bundles_as_variants y memory/project_releasit_cod_pattern.
   ============================================================ */
(function () {
  var root = document.querySelector('.vaporseguro-landing');
  if (!root) return;

  /* ============================================================
     1. Countdown de la barra superior
     ============================================================ */
  (function () {
    var H = document.getElementById('h'), M = document.getElementById('m'), S = document.getElementById('s');
    if (!H || !M || !S) return;
    var total = 2 * 3600 + 9 * 60;
    var p = function (n) { return String(n).padStart(2, '0'); };
    setInterval(function () {
      if (total <= 0) total = 2 * 3600 + 9 * 60;
      total--;
      H.textContent = p(Math.floor(total / 3600));
      M.textContent = p(Math.floor((total % 3600) / 60));
      S.textContent = p(total % 60);
    }, 1000);
  })();

  /* ============================================================
     2. Galería (thumbs -> imagen principal)
     ============================================================ */
  root.querySelectorAll('.vs-thumbs .vs-slot').forEach(function (t) {
    t.addEventListener('click', function () {
      root.querySelectorAll('.vs-thumbs .vs-slot').forEach(function (x) { x.classList.remove('on'); });
      t.classList.add('on');
      var main = root.querySelector('#mainImg img');
      if (main && t.dataset.img) main.src = t.dataset.img;
    });
  });

  /* ============================================================
     3. Releasit COD — variante + cantidad en el DOM, click botón nativo
     ============================================================ */
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    // Releasit lee la cantidad de input[name="quantity"] al abrir el modal
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(q);
      input.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* ---------- selección de bundle ---------- */
  var selectedVariantId = null;
  var selectedQty = 1;
  var bundles = root.querySelectorAll('.vs-bundle');

  function pickBundle(b) {
    bundles.forEach(function (x) {
      x.classList.remove('on');
      var i = x.querySelector('input');
      if (i) i.checked = false;
    });
    b.classList.add('on');
    var inp = b.querySelector('input');
    if (inp) inp.checked = true;

    var now = root.querySelector('.vs-price .now');
    var was = root.querySelector('.vs-price .was');
    var save = root.querySelector('.vs-save');
    if (now && b.dataset.total) now.textContent = b.dataset.total;
    if (was && b.dataset.was) was.textContent = b.dataset.was;
    if (save && b.dataset.save) save.textContent = '🏷️ ' + b.dataset.save;

    var id = b.getAttribute('data-bundle-variant-id');
    if (id) {
      selectedVariantId = id;
      selectedQty = parseInt(b.getAttribute('data-bundle-qty'), 10) || 1;
      setVariantOnAllForms(selectedVariantId, selectedQty);
    }
  }
  bundles.forEach(function (b) { b.addEventListener('click', function () { pickBundle(b); }); });

  function clickNativeReleasit() {
    var rb = findReleasitButton();
    if (rb) { rb.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = findReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        // último recurso: abre el modal con la variante que Releasit cacheó
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }

  function triggerCOD(btn) {
    var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || selectedVariantId;
    var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || selectedQty;
    if (variantId) setVariantOnAllForms(variantId, qty);
    setTimeout(clickNativeReleasit, 50);
  }
  window.vaporseguroTriggerCOD = triggerCOD;

  /* todos los CTA de compra abren el modal COD con el bundle activo */
  root.querySelectorAll('.vs-cta').forEach(function (btn) {
    btn.addEventListener('click', function () { triggerCOD(null); });
  });

  /* init: bundle preseleccionado (.on o el primero) */
  var active = root.querySelector('.vs-bundle.on') || bundles[0];
  if (active) pickBundle(active);

  /* ============================================================
     4. Carrusel de mini reseñas del hero
     ============================================================ */
  var hi = 0;
  function hrev(d) {
    var track = document.getElementById('hrevTrack');
    if (!track || !track.children.length) return;
    var n = track.children.length;
    hi = (hi + d + n) % n;
    var w = track.children[0].getBoundingClientRect().width;
    track.style.transform = 'translateX(-' + (hi * w) + 'px)';
  }
  window.hrev = hrev;
  window.addEventListener('resize', function () { hrev(0); });
  setInterval(function () { hrev(1); }, 5000);

  /* ============================================================
     5. Barras de estadísticas animadas
     ============================================================ */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var card = e.target;
        var pctEl = card.querySelector('.pct');
        var fill = card.querySelector('.fill');
        if (!pctEl || !fill) return;
        var target = +pctEl.dataset.target;
        requestAnimationFrame(function () { fill.style.width = target + '%'; });
        var dur = 1300, t0 = performance.now();
        function tick(now) {
          var p = Math.min(1, (now - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          pctEl.textContent = Math.round(eased * target) + '%';
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        io.unobserve(card);
      });
    }, { threshold: .45 });
    root.querySelectorAll('.vs-statcard').forEach(function (c) { io.observe(c); });
  })();

  /* ============================================================
     6. Marquesinas
     ============================================================ */
  var marqItems = ['Limpieza Rápida', 'Fácil de Usar', 'Totalmente Seguro', 'Accesorios Versátiles'];
  function fillMarq(id, items, reps) {
    var el = document.getElementById(id);
    if (!el) return;
    var s = '';
    for (var r = 0; r < reps; r++) { items.forEach(function (t) { s += '<span>' + t + '</span>'; }); }
    el.innerHTML = s;
  }
  fillMarq('m1', marqItems, 6);
  fillMarq('m2', marqItems, 6);

  /* ============================================================
     7. Banda de sellos
     El HTML fuente traía aquí los logos (SVG recreados) de El Tiempo,
     Semana, Caracol, RCN y El Espectador. Eso afirma una cobertura de
     prensa que no existe y usa marcas de terceros, así que va la banda con
     los sellos propios del producto. Si Daniel consigue cobertura real (o
     autorización), se reemplaza por los logos que corresponda.
     ============================================================ */
  fillMarq('press', [
    '✓ Vapor a presión',
    '✓ 12 accesorios incluidos',
    '✓ Sin químicos',
    '✓ Pago contra entrega',
    '✓ Envío gratis a Colombia',
    '✓ Garantía 30 días'
  ], 3);
})();
